import { DIALOG_IDS, modalStore } from '@core/modal'
import { useActions, useValues } from '@core/store'

import { likeStore } from '../store/likeStore'

// `open()` also marks the flag so the dialog never shows again; `hasSeen` lets the caller gate it.
export const useFirstLikeDialog = () => {
    const [hasSeen] = useValues([likeStore.props.getHasLikedBefore])
    const actions = useActions({
        markLikedBefore: likeStore.actions.markLikedBefore,
        openModal: modalStore.actions.open,
        closeModal: modalStore.actions.close,
    })

    const open = () => {
        actions.markLikedBefore()
        actions.openModal(DIALOG_IDS.firstLike)
    }

    const close = () => {
        actions.closeModal()
    }

    return { hasSeen, open, close }
}
